import { Box } from 'braid-design-system';
import React from 'react';
import type { ClassRendererProps } from '../types';

export function Class({ className, children }: ClassRendererProps) {
  return <Box className={className}>{children}</Box>;
}
